module.exports = __webpack_public_path__ + "static/media/wackyArmGuyTransparent.11626741.gif";